var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1972,
    height: 392,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3B82F6",
    stopOpacity: 0.32,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "c"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D946EF",
    stopOpacity: 0.64,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D946EF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-33.6%",
    y: "-32.6%",
    width: "167.1%",
    height: "165.2%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-33.6%",
    y: "-32.6%",
    width: "167.1%",
    height: "165.2%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1364.5 0C1241.064 0 1141 102.975 1141 230s100.064 230 223.5 230S1588 357.025 1588 230C1587.857 103.036 1487.876.147 1364.5 0Zm107.16 308.341c-1.892 2.323-4.973 3.231-7.78 2.295l-98.896-32.908-98.896 32.908c-2.807.933-5.884.022-7.774-2.3-1.89-2.32-2.212-5.587-.815-8.25l101.128-192.49c1.376-2.238 3.776-3.596 6.357-3.596 2.58 0 4.981 1.358 6.357 3.596l101.128 192.49c1.401 2.663 1.08 5.932-.81 8.255Z",
    fill: "url(#a)",
    filter: "url(#b)",
    transform: "translate(0 -286)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1636.5 147c-123.436 0-223.5 102.975-223.5 230s100.064 230 223.5 230S1860 504.025 1860 377c-.143-126.964-100.124-229.853-223.5-230Zm107.16 308.341c-1.892 2.323-4.973 3.231-7.78 2.295l-98.896-32.908-98.896 32.908c-2.807.933-5.884.022-7.774-2.3-1.89-2.32-2.212-5.587-.815-8.25l101.128-192.49c1.376-2.238 3.776-3.596 6.357-3.596 2.58 0 4.981 1.358 6.357 3.596l101.128 192.49c1.401 2.663 1.08 5.932-.81 8.255Z",
    fill: "url(#c)",
    filter: "url(#d)",
    transform: "translate(0 -286)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIllustration);
export default __webpack_public_path__ + "static/media/hero-illustration.0e25c5979b0a5fbb7dfc939fa4ad3e18.svg";
export { ForwardRef as ReactComponent };